(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('InvoicePaymentDetailController', InvoicePaymentDetailController);

    InvoicePaymentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'InvoicePayment', 'Invoice'];

    function InvoicePaymentDetailController($scope, $rootScope, $stateParams, previousState, entity, InvoicePayment, Invoice) {
        var vm = this;

        vm.invoicePayment = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ccsTrApp:invoicePaymentUpdate', function(event, result) {
            vm.invoicePayment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
